import { LocalStorage } from '../../utils/localstorage'
import { isEmpty } from 'lodash'
import { User } from '../../models/user'
import { UserState } from '../states'
import { UserAction, UserActionTypes } from '../../models/userAction'
import { UserPermissions } from '../../models/permissions'
import { I18n } from '../../models/i18n'
import { isProd } from '../../Techedge-digitalportal-shared'
// import { beforeUnloadCallback } from '../../utils/commonFunctions'

let defaultstate: UserState = {
    isUserAuthenticated: false,
    user: new User(),
    loading: false,
    accessToken: '',
    refreshToken: '',
    i18n: new I18n(),
    permissions: new UserPermissions(),
    smartlyPermissionUpdated: false,
    isAdminSocialHub: false,
}

const persistentData: UserState = LocalStorage._shared().getPersistentData()

if (persistentData) {
    defaultstate = {
        isUserAuthenticated: !isEmpty(persistentData.accessToken)
            ? true
            : false,
        user: persistentData.user || new User(),
        loading: false,
        accessToken: persistentData.accessToken,
        refreshToken: persistentData.refreshToken,
        i18n: persistentData.i18n,
        permissions: persistentData.permissions,
        isAdminSocialHub: false,
    }
}

export default (state: UserState = defaultstate, action: any) => {
    switch (action.type) {
        case UserActionTypes.USER_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case UserActionTypes.USER_TOKEN:
            return {
                ...state,
                accessToken: action.response.accessToken,
                isUserAuthenticated: true,
                loading: !action.response.loading,
            }
        case UserActionTypes.USER_PORTAL:
            return {
                ...state,
                permissions: {
                    ...state.permissions,
                    selectedPortal: action.response.code,
                },
            }
        case UserActionTypes.USER_SUCCESS:
            return {
                ...state,
                isUserAuthenticated: true,
                user: { ...state.user, ...action.response.user },
                accessToken: action.response.accessToken,
                refreshToken: action.response.refreshToken,
                isAdminSocialHub: action.response.isAdminSocialHub,
            }
        case UserActionTypes.USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                permissions: action.response,
            }
        case UserActionTypes.USER_SWITCH_LOCALE_SUCCESS:
            return {
                ...state,
                loading: false,
                i18n: { ...state.i18n, locale: action.response },
            }
        case UserActionTypes.USER_LOGOUT:
            // if (isProd()) {
            // TODO: Insert isProd() check
            const nonce = localStorage.getItem('LUX_SMARTLY_nonce')
            if (nonce) {
                localStorage.removeItem('LUX_SMARTLY_nonce')
                window.location.href = process.env.NETIQ_LOGOUT_URL + nonce
            } else {
                window.location.href = process.env.NETIQ_LOGOUT_URL
            }
            return {
                ...state,
                isUserAuthenticated: false,
            }
        case UserActionTypes.USER_ERROR:
            let isUserAuthenticated: boolean = state.isUserAuthenticated
            if (action && action.response && action.response.response) {
                isUserAuthenticated = action.response.response.status !== 401
            }
            return {
                ...state,
                loading: false,
                isUserAuthenticated: isUserAuthenticated,
            }
        case UserActionTypes.SMARTLY_PERMISSION_UPDATED:
            return {
                ...state,
                smartlyPermissionUpdated: true,
            }
        default:
            return state
    }
}
